var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRevenue = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1724_1532",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.332031,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1724_1532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.332 12.9995C15.1654 12.9995 15.8737 12.7078 16.457 12.1245C17.0404 11.5411 17.332 10.8328 17.332 9.99945C17.332 9.16612 17.0404 8.45778 16.457 7.87445C15.8737 7.29112 15.1654 6.99945 14.332 6.99945C13.4987 6.99945 12.7904 7.29112 12.207 7.87445C11.6237 8.45778 11.332 9.16612 11.332 9.99945C11.332 10.8328 11.6237 11.5411 12.207 12.1245C12.7904 12.7078 13.4987 12.9995 14.332 12.9995ZM7.33203 15.9995C6.78203 15.9995 6.31136 15.8035 5.92003 15.4115C5.52803 15.0201 5.33203 14.5495 5.33203 13.9995V5.99945C5.33203 5.44945 5.52803 4.97878 5.92003 4.58745C6.31136 4.19545 6.78203 3.99945 7.33203 3.99945H21.332C21.882 3.99945 22.353 4.19545 22.745 4.58745C23.1364 4.97878 23.332 5.44945 23.332 5.99945V13.9995C23.332 14.5495 23.1364 15.0201 22.745 15.4115C22.353 15.8035 21.882 15.9995 21.332 15.9995H7.33203ZM3.33203 19.9995C2.78203 19.9995 2.31136 19.8038 1.92003 19.4125C1.52803 19.0205 1.33203 18.5495 1.33203 17.9995V7.99945C1.33203 7.71612 1.42803 7.47845 1.62003 7.28645C1.81136 7.09512 2.0487 6.99945 2.33203 6.99945C2.61536 6.99945 2.85303 7.09512 3.04503 7.28645C3.23636 7.47845 3.33203 7.71612 3.33203 7.99945V17.9995H19.332C19.6154 17.9995 19.8527 18.0955 20.044 18.2875C20.236 18.4788 20.332 18.7161 20.332 18.9995C20.332 19.2828 20.236 19.5201 20.044 19.7115C19.8527 19.9035 19.6154 19.9995 19.332 19.9995H3.33203ZM7.33203 7.99945C7.88203 7.99945 8.3527 7.80345 8.74403 7.41145C9.13603 7.02012 9.33203 6.54945 9.33203 5.99945H7.33203V7.99945ZM21.332 7.99945V5.99945H19.332C19.332 6.54945 19.5277 7.02012 19.919 7.41145C20.311 7.80345 20.782 7.99945 21.332 7.99945ZM7.33203 13.9995H9.33203C9.33203 13.4495 9.13603 12.9785 8.74403 12.5865C8.3527 12.1951 7.88203 11.9995 7.33203 11.9995V13.9995ZM19.332 13.9995H21.332V11.9995C20.782 11.9995 20.311 12.1951 19.919 12.5865C19.5277 12.9785 19.332 13.4495 19.332 13.9995Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRevenue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/revenue.dd2ffd70.svg";
export { ForwardRef as ReactComponent };